function MFRReviews(index, element) {
  this.$element = $(element)

  this.selectors = {
    reviewsContainer: "#reviews-listing",
    reviewCounterInput: "#review-counter",
    reviewCounterLimitInput: "#review-counter-limit",
    loadMoreButton: "#load-more",
  }

  this.states = {
    reviewList: "",
    newReviewList: "",
    reviewsTotal: 0,
    reviewsTotalCounter: 0,
    reviewsTotalCounterLimit: 0,
    reviewLimit: 10,
    reviewCounter: 0
  }

  this.months = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec']
  this.reviewsPayload = []

  this.init()
}

MFRReviews.prototype = Object.assign({}, MFRReviews.prototype, {
  init: function () {
    this.$reviewsContainer = this.$element.find(this.selectors.reviewsContainer)
    this.$loadMoreButton = this.$element.find(this.selectors.loadMoreButton)
    this.$reviewCounterInput = this.$element.find(this.selectors.reviewCounterInput)
    this.$reviewCounterLimitInput = this.$element.find(this.selectors.reviewCounterLimitInput)

    $(window).on("load", this.__handleInitializaton.bind(this))
    $(window).on("resize", this.__handleInitializaton.bind(this))

    this.$loadMoreButton.on("click", this.__handleLoadMoreReviews.bind(this))
  },

  __handleInitializaton: function() {
    this.__handleGetAPIReviews()
  },

  __handleGetAPIReviews: function() {
    $.ajax({
      url: '/wp-content/themes/alden-properties/local-json/reputation-reviews-local.json',
      type: 'get',
      dataType: 'json',
      success: data => {
        this.reviewsPayload = data
      }
    }).then(() => {
      this.__handleInitialReviewsDisplay(this.reviewsPayload)
    })
  },

  __handleInitialReviewsDisplay: function(payload) {
    this.__handleNoReviews(payload)

    const availableReviews = this.__handleCheckReview(this.reviewsPayload.reviews)
  
    availableReviews.forEach(review => {
      this.states.reviewsTotal++

      if (this.states.reviewCounter > this.states.reviewLimit) return

      let { rating, reviewer, sourceID, date, comment } = review
      let splitDate = date.split('T')
      let formatDate = splitDate[0].split('-')

      this.states.reviewList += `
        <div class="review-item">
          <div class="review-item--rating">
            <svg id="stars" version="1.1" style="display: none;">
              <symbol id="emptyStar" fill="#e2e2e2">
                <path d="m 9.5 14.25 l -5.584 2.936 l 1.066 -6.218 l -4.517 -4.404 l 6.243 -0.907 l 2.792 -5.657 l 2.792 5.657 l 6.243 0.907 l -4.517 4.404 l 1.066 6.218 z"></path>
              </symbol> 
              <symbol id="fullStar" fill="#FB7044">
                <path d="m 9.5 14.25 l -5.584 2.936 l 1.066 -6.218 l -4.517 -4.404 l 6.243 -0.907 l 2.792 -5.657 l 2.792 5.657 l 6.243 0.907 l -4.517 4.404 l 1.066 6.218 z"></path>
              </symbol>
            </svg>

            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 20">
              <use href="${rating >= 1 ? '#fullStar' : '#emptyStar'}"></use> 
              <use href="${rating >= 2 ? '#fullStar' : '#emptyStar'}"></use> 
              <use href="${rating >= 3 ? '#fullStar' : '#emptyStar'}"></use>
              <use href="${rating >= 4 ? '#fullStar' : '#emptyStar'}"></use>
              <use href="${rating >= 5 ? '#fullStar' : '#emptyStar'}"></use>
            </svg>
          </div>
          <div class="review-item--header">
            <div>
              <h5>${reviewer.name != null ? reviewer.name : 'Anonymous'}</h5>
              <h5>${sourceID != null ? sourceID : ''}</h5>
            </div>
            <div>
              <h5>${this.months[Number(formatDate[1]) - 1]} ${formatDate[2]}, ${formatDate[0]}</h5>
            </div>
          </div>
          <div class="review-item--body">
            <p>${comment != null ? comment : ''}</p>
          </div>
        </div>
      `

      this.states.reviewCounter++
    })

    this.$reviewsContainer.html(this.states.reviewList)
  },

  __handleLoadMoreReviews: function(event) {
    event.preventDefault()

    this.__handleIncrementCounter('review-counter', 10)
    this.__handleIncrementCounter('review-counter-limit', 10)

    let reviewsTotalCounter = Number(this.$reviewCounterInput.val())
    let reviewsTotalCounterLimit = Number(this.$reviewCounterLimitInput.val())

    const availableReviews = this.__handleCheckReview(this.reviewsPayload.reviews)

    availableReviews.slice(reviewsTotalCounterLimit, reviewsTotalCounter).forEach(review => {
      let { rating, reviewer, sourceID, date, comment } = review
      let splitDate = date.split('T')
      let formatDate = splitDate[0].split('-')

      this.states.newReviewList += `
        <div class="review-item">
          <div class="review-item--rating">
            <svg id="stars" version="1.1" style="display: none;">
              <symbol id="emptyStar" fill="#e2e2e2">
                <path d="m 9.5 14.25 l -5.584 2.936 l 1.066 -6.218 l -4.517 -4.404 l 6.243 -0.907 l 2.792 -5.657 l 2.792 5.657 l 6.243 0.907 l -4.517 4.404 l 1.066 6.218 z"></path>
              </symbol> 
              <symbol id="fullStar" fill="#FB7044">
                <path d="m 9.5 14.25 l -5.584 2.936 l 1.066 -6.218 l -4.517 -4.404 l 6.243 -0.907 l 2.792 -5.657 l 2.792 5.657 l 6.243 0.907 l -4.517 4.404 l 1.066 6.218 z"></path>
              </symbol>
            </svg>

            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 20">
              <use href="${rating >= 1 ? '#fullStar' : '#emptyStar'}"></use> 
              <use href="${rating >= 2 ? '#fullStar' : '#emptyStar'}"></use> 
              <use href="${rating >= 3 ? '#fullStar' : '#emptyStar'}"></use>
              <use href="${rating >= 4 ? '#fullStar' : '#emptyStar'}"></use>
              <use href="${rating >= 5 ? '#fullStar' : '#emptyStar'}"></use>
            </svg>
          </div>
          <div class="review-item--header">
            <div>
              <h5>${reviewer.name != null ? reviewer.name : 'Anonymous'}</h5>
              <h5>${sourceID != null ? sourceID : ''}</h5>
            </div>
            <div>
              <h5>${this.months[Number(formatDate[1]) - 1]} ${formatDate[2]}, ${formatDate[0]}</h5>
            </div>
          </div>
          <div class="review-item--body">
            <p>${comment != null ? comment : ''}</p>
          </div>
        </div>
      `
    })

    this.$reviewsContainer.append(this.states.newReviewList)

    if (reviewsTotalCounter >= this.states.reviewsTotal) {
      this.$loadMoreButton.addClass('disabled')
    }

    this.states.newReviewList = ''
  },

  __handleNoReviews: function(payload) {
    if (!payload) {
      this.$reviewsContainer.html('<p class="text-center">No reviews found.</p>')
      this.states.reviewsTotal === 0 ? this.$loadMoreButton.hide() : this.$loadMoreButton.show()

      return
    }
  },

  __handleCheckReview: function(payload) {
    return payload.filter(review => (review.published && review.locationName == window.propertyData.name && review.sentiment != 'Negative'))
  },

  __handleIncrementCounter: function(el, val) {
    let value = parseInt(document.getElementById(el).value, val)
    value = isNaN(value) ? 0 : value
    value += 10
    document.getElementById(el).value = value
  }
})